<template>
  <section id="products" class="card background-opacity text-white p-5">
    <!-- Título -->
    <div class="text-center mb-5">
      <h1 class="orbitron-font text-title">Our Products</h1>
      <p class="fs-5" style="max-width: 700px; margin: 0 auto">Solutions designed to boost your business with modern, efficient, and secure technology.</p>
    </div>
    <!-- GRID -->
    <div class="row g-4 justify-content-center">
      <!-- Producto 1 -->
      <div class="col-md-4">
        <div class="card product-card p-4 text-center align-items-center">
          <img class="img-aspect-ratio w-50" src="/images/products/IsotipoHandLab.png" alt="Imagen de Producto: HandLab Analytics" />
          <h4 class="fw-bold oswald-font mb-2">
            <!-- <i class="fa-solid fa-hand-sparkles product-icon"></i> -->
            HandLab Analytics
          </h4>
          <p>Analysis and therapy platform for patients with hand and upper limb disorders.</p>
          <div class="my-2" style="display: flex; flex-wrap: wrap; gap: 2px; align-items: flex-start">
            <span class="badge badge-white badge-border badge-transparent">Quantifiable Analysis</span>
            <span class="badge badge-white badge-border badge-transparent">Video Analytics</span>
            <span class="badge badge-white badge-border badge-transparent">Guided Training</span>
            <span class="badge badge-white badge-border badge-transparent">Rehabilitation Protocols</span>
            <span class="badge badge-white badge-border badge-transparent">Hands</span>
            <span class="badge badge-white badge-border badge-transparent">Arms</span>
            <span class="badge badge-white badge-border badge-transparent">Torso</span>
          </div>
          <a href="https://handlabanalytics.com/" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-neon hover-simple main w-50" style="color: var(--Black) !important"> See More </a>
        </div>
      </div>
      <!-- Producto 2 - Destacado -->
      <!-- <div class="col-md-4">
        <div class="card product-card featured p-4 text-center">
          <h4 class="fw-bold oswald-font mb-2 text-white">
            <i class="fa-solid fa-shield-halved product-icon"></i>
            Template Title
          </h4>
          <p>Template Content.</p>
          <a href="https://aialphaanalytics.com/" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-neon hover-simple main  w-50" style="color: var(--Black) !important"> See More </a>
        </div>
      </div> -->
      <!-- Producto 3 -->
      <div class="col-md-4">
        <div class="card product-card p-4 text-center align-items-center">
          <img class="img-aspect-ratio" src="/images/products/IsotipoFaceLab.png" alt="Imagen de Producto: FaceLab Analytics" />
          <h4 class="fw-bold oswald-font mb-2">
            <!-- <i class="fa-solid fa-face-laugh-wink product-icon"></i> -->
            FaceLab Analytics
          </h4>
          <p>Platform for analysis and facial therapy for patients with facial movement disorders.</p>
          <div class="my-2" style="display: flex; flex-wrap: wrap; gap: 2px; align-items: flex-start">
            <span class="badge badge-white badge-border badge-transparent">Quantifiable Analysis</span>
            <span class="badge badge-white badge-border badge-transparent">Video Analytics</span>
            <span class="badge badge-white badge-border badge-transparent">Guided Training</span>
            <span class="badge badge-white badge-border badge-transparent">Preset Therapies</span>
            <span class="badge badge-white badge-border badge-transparent">Face</span>
          </div>
          <a href="https://facelabanalytics.com/" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-neon hover-simple main w-50" style="color: var(--Black) !important"> See More </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { GlobalMixin } from '@mixins/GlobalMixin.js';

export default {
  mixins: [GlobalMixin],
  name: 'Products',
  data() {
    return {};
  },
};
</script>

<style scoped>
.product-card {
  height: 100%;
  border: none;
  border-radius: 20px;
  flex-direction: column;
  transition: all 0.25s ease;
  background: -webkit-linear-gradient(rgb(205, 255, 255, 0.9), rgb(32, 147, 193, 0.7));

  a {
    margin-top: auto;
  }

  img {
    max-width: 100px;
    max-height: 100px;
    width: 100%;
    height: auto;
    object-fit: contain;
    margin: 0 auto;
  }
}

.product-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.product-icon {
  color: var(--Dark-Sky);
  font-size: 1.3em;
}

.product-card:hover {
  transform: translateY(-10px);
}

.featured {
  background: var(--Midnight-Sky);
}
</style>
